import { api } from "../api";
import ActionType from "../utils/customTypes";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class LibraryService extends api {

    private static classInstance?: LibraryService;
        
    constructor(token: string, type: ActionType) {
        super( process.env.REACT_APP_BASE_URL,token);    
    } 
     
    public static getInstance() {
        let token = cookies.get('stkc');
        if (!this.classInstance) {
            this.classInstance = new LibraryService(token!==undefined?token:'', 'GET');
        }
        
        return this.classInstance;
    }   
     
    public getLibrary = () => this.instance.post('/library/get-library-documents').then(response => {
        if (response) {
            return response;
        }
    
    }).catch((error: any) => {
        return Promise.reject(error);
    });

    

}